export const CARD_HEIGHT = {
  profile: '286px',
  profileMobile: '284px',
  public: '191px'
} as const;
